// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_contextMenuItem_YmcWTo1HBsO1Z9fZG_uQ {
  display: flex;
  align-items: baseline;
  padding: 2px;
}
.style-module_contextMenuItemLabel_vTddEYcLeUafwMP4ovdb {
  margin-left: 16px;
  color: #031c2d;
}

.style-module_nativeLabel_bQlGj5htEAlv2da0t1kP {
  font-style: italic;
}

.style-module_navigationButton_Vlh6hiZO9AuLTIfrdA9Q {
  background-color: #34a3d9;
}`, "",{"version":3,"sources":["webpack://./src/components/LoggedOutMainNavigation/style.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qBAAA;EACA,YAAA;AACF;AACE;EACE,iBAAA;EACA,cAAA;AACJ;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF","sourcesContent":[".contextMenuItem {\n  display: flex;\n  align-items: baseline;\n  padding: 2px;\n\n  &Label {\n    margin-left: 16px;\n    color: #031c2d;\n  }\n}\n\n.nativeLabel {\n  font-style: italic;\n}\n\n.navigationButton {\n  background-color: #34a3d9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contextMenuItem": `style-module_contextMenuItem_YmcWTo1HBsO1Z9fZG_uQ`,
	"contextMenuItemLabel": `style-module_contextMenuItemLabel_vTddEYcLeUafwMP4ovdb`,
	"nativeLabel": `style-module_nativeLabel_bQlGj5htEAlv2da0t1kP`,
	"navigationButton": `style-module_navigationButton_Vlh6hiZO9AuLTIfrdA9Q`
};
export default ___CSS_LOADER_EXPORT___;
